import React, { Component } from "react";
import Functions from "../../src/functions";

class Placeholder extends Component {
  state = {
    content: "",
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
  };

  constructor(props) {
    super(props);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }

    let defaultValue = "";
    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }

    this.state = {
      events: events,
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: this.props.value ? this.props.value : defaultValue,
    };
  }

  componentDidMount() {
    this.setState({
      content: "",
      attributes: this.props.property.attributes,
      name: this.props.property.alias,
      loaded: true,
      placeholder: this.props.property.placeholder
        ? this.props.property.placeholder
        : "",
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      customUI: this.props.property.customUI,
      useCustomUI:
        typeof this.props.property.useCustomUI !== "undefined"
          ? this.props.property.useCustomUI
          : true,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  render() {
    if (this.state.loaded) {
      return this.state.content;
    }
    return "";
  }
}

export default Placeholder;
